/* eslint-disable @typescript-eslint/no-explicit-any */

import { typeCheck } from "@/lib/type-check";
import { DocumentListingItem } from "./document-listing-item";
import { Fragment } from "react/jsx-runtime";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { DocumentTableV3 } from "./document-table-v3";
import { useMemo } from "react";
import { cn } from "@/lib/utils";
import { ActionColumn } from "./action-column";
import { IsSimilarityMatch } from "./is-similarity-match";
import { getObject } from "@/lib/object-mutation";
import { IgnorePriceValidationColumn } from "./ignore-price-validation-column";

export const DocumentListingV2 = ({
  data,
  parentKey,
  originalDetailsData,
}: any) => {
  const getValue = (value: any) => {
    if ("text" in value) {
      return value?.text;
    }

    if (value === null || value?.text === null) {
      return "";
    }
    return value;
  };

  const isArrayExist = useMemo(() => {
    for (const key in data) {
      const currentText = getValue(data[key]);
      const checkType = typeCheck(currentText);
      if (checkType === "Array") {
        return true;
      }
    }
    return false;
  }, [data]);

  const getLocalKey = parentKey?.replace("detailsData.", "");
  const currentData = getObject(originalDetailsData, getLocalKey);

  const temp_reviewed = currentData.reviewed;
  // const temp_review_required = currentData.review_required;

  const review_required = currentData.review_required;
  const data_review_required = data?.review_required;
  // const reviewed = data.reviewed;
  const review_required_row_no = review_required
    ?.filter((rrItem: any) => rrItem.text === "true")
    .map((crrItem: any) => crrItem.row_number);

  const rrdata = data.reviewed;
  const warnings = data.warnings;

  return (
    <div className="overflow-x-auto pb-1 max-h-[400px]">
      <div
        className={cn("w-max min-w-full text-99999999", {
          "max-w-full": !isArrayExist,
        })}
      >
        {Object.entries(data).map(([key, value]: any, index: number, arr) => {
          const currentText = getValue(value);
          const checkType = typeCheck(currentText);
          const currentKey = value?.regions
            ? `${parentKey}.${key}.text`
            : `${parentKey}.${key}`;

          return (
            <Fragment key={key}>
              <ConditionRenderer condition={checkType === "Array"}>
                <>
                  {!["reviewed", "review_required", "warnings"].includes(
                    key,
                  ) ? (
                    <DocumentTableV3
                      data={value}
                      keyValue={key}
                      parentKey={`${parentKey}.${key}`}
                      rowNumber={index}
                      review_required_row_no={review_required_row_no || []}
                      temp_reviewed={temp_reviewed}
                    />
                  ) : null}
                </>
                <>
                  <DocumentListingItem
                    parentKey={currentKey}
                    data={currentText}
                    keyValue={key}
                    isFirstRow={index === 0}
                    is_flagged={value?.is_flagged ? true : false}
                  />
                </>
              </ConditionRenderer>
              {arr.length - 1 === index ? (
                <ConditionRenderer condition={checkType === "Array"}>
                  <div className="float-left sticky top-0 right-0 z-[12] flex">
                    {review_required ? (
                      <IsSimilarityMatch
                        data={rrdata}
                        parentKey={parentKey}
                        keyValue={key}
                        review_required={review_required}
                        review_required_row_no={review_required_row_no}
                        // originalDetailsData={originalDetailsData}
                        temp_reviewed={temp_reviewed}
                        data_review_required={data_review_required}
                      />
                    ) : null}
                    <IgnorePriceValidationColumn
                      data={value}
                      parentKey={parentKey}
                      review_required={review_required}
                      review_required_row_no={review_required_row_no}
                      arr={data}
                    />
                    <ActionColumn
                      data={value}
                      parentKey={parentKey}
                      keyValue={key}
                      review_required_row_no={review_required_row_no || []}
                      temp_reviewed={temp_reviewed}
                      warnings={warnings}
                    />
                  </div>
                  <></>
                </ConditionRenderer>
              ) : null}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
